import { SearchRequest } from "@/types/search/SearchRequest";

export function hasFilterApplied(model: SearchRequest | null | undefined): boolean {
	if (!model) {
		return false;
	}
	return Boolean(
		model.startDate ||
		model.endDate ||
		model.dateFilter ||
		(model.statuses?.length ?? 0) > 0 ||
		(model.labels?.length ?? 0) > 0 ||
		(model.userIds?.length ?? 0) > 0 ||
		(model.createdByIds?.length ?? 0) > 0 ||
		(model.customerIds?.length ?? 0) > 0 ||
		(model.contentTypes?.length ?? 0) > 0 ||
		(model.organization && model.organization !== "current") ||
		model.latitude ||
		model.longitude
	);
}
